export default {
    common: {
        ok: '确定',
        cancel: '取消',

        tab_bookcase: '书架',
        tab_library: '书库',
        tab_welfare: '福利',
        tab_my: '我的',

        library_refresh_success: '刷新成功',
        library_loading: '加载中...',
        pull_refresh_pulling: '下拉即可刷新...',
        pull_refresh_loosing: '释放即可刷新...',
        library_no_books: '暂无书籍',
        library_list_end: '我是有底线的~',

        library_more: '更多',
        library_score_suffix: '分',
        library_hot: '热度',
        library_serializing: '连载中',
        library_finished: '已完结',
        library_no_image: '暂无图片展示',
        library_no_more: '没有更多了',

        more_title: '今日必读',
        more_tab_new: '新书',
        more_tab_finish: '完结',

        directory_title: '目录',
        directory_chapters: '共{0}章',
        free: '免费',
        no_chapters: '暂无章节',

        details_title: '书籍详情',
        details_reading: '在读',
        details_popularity: '人气',
        details_catalog: '查看目录',
        details_updated_at: '更新于',
        details_chapters_suffix: '章',
        details_comments_section: '评论区',
        details_comments_suffix: '条评论',
        details_write_review: '写评论',
        details_no_comments: '暂无评论',
        details_view_all: '查看全部',
        details_guess_like: '猜你喜欢',
        details_refresh: '换一换',
        details_in_shelf: '已在书架',
        details_add_shelf: '加入书架',
        details_read_now: '立即阅读',

        book_review_title: '书评',
        free_read: '免费阅读',
        rating_bad: '不好',
        rating_fair: '一般',
        rating_ok: '还行',
        rating_good: '不错',
        rating_best: '力荐',
        people_rated_suffix: '人评分',
        review_write: '写评论',
        tab_review_new: '最新书评',
        tab_review_recommend: '推荐书评',
        no_reviews: '暂无评价',

        bookdetails_title: '书评详情',
        eval_title: '评价本书',
        eval_publish: '发布',
        eval_placeholder: '请从故事情节，人物性格等方面打分并表达你的看法',
        eval_success: '评论成功',

        reading_need_beans: '本章需要',
        reading_beans: '书豆',
        reading_need_beans_suffix: '阅读',
        reading_read_minutes: '已阅读',
        reading_minutes_suffix: '分钟',
        login_btn: '登录',
        follow_qr_tip: '长按识别二维码关注公众号',
        unlock_more: '解锁更多章节',
        follow_refresh_tip: '已关注，请点击右上角进行刷新',
        auth_login_toast: '授权登录',
        login_success_toast: '登录成功',
        add_shelf_confirm_title: '加入书架',
        add_shelf_confirm_msg: '是否将本书加入书架',
        add_shelf_confirm_btn: '加入书架',
        add_shelf_cancel_btn: '暂不加入',
        please_login_toast: '请登录',
        vip_activated_toast: '已开通畅读vip',
        auto_buy_on_toast: '开启自动购买章节',
        auto_buy_off_toast: '关闭自动购买章节',
        pay_price_label: '价格',
        pay_balance_label: '余额',
        purchase_success_toast: '成功购买章节！',
        last_page_toast: '已经是最后一页了',
        first_page_toast: '已经是第一页了',

        login_account: '账号登录',
        login_code: '验证码登录',
        login_phone_placeholder: '请输入手机号',
        login_password_placeholder: '请输入密码',
        login_btn_text: '登录',
        login_forget: '忘记密码',
        login_register: '新用户注册',
        login_wx: '微信一键登录',
        login_qq: 'QQ一键登录',
        login_facebook: '使用 Facebook 登录',
        login_google: '使用 Google 登录',
        login_continue_email: '使用邮箱继续',
        login_or: '或',
        login_agreement_prefix: '登录即表示您同意',
        login_user_agreement: '用户协议',
        login_and: '和',
        login_privacy: '隐私政策',
        login_success: '登录成功',
        login_code_placeholder: '请输入验证码',
        login_get_code: '获取验证码',
        login_resend_after: '秒后再次获取',
        login_send_fail: '发送失败',

        settings_title: '设置',
        settings_avatar: '头像',
        settings_nickname: '昵称',
        settings_gender: '性别',
        settings_gender_placeholder: '请选择你的性别',
        settings_male: '男',
        settings_female: '女',
        settings_secret: '保密',
        settings_signature: '个性签名',
        settings_account_binding: '账号和绑定设置',
        settings_logout: '退出登录',
        settings_edit_nickname: '修改昵称',
        settings_nickname_placeholder: '请输入昵称~',
        settings_nickname_rule: '2-10个字符，允许中文、英文、数字',
        settings_updating: '修改中...',
        settings_avatar_success: '修改头像成功',
        settings_success: '修改成功',
        settings_nickname_short: '昵称不得少于2个字符',
        settings_logout_title: '退出登录',
        settings_logout_msg: '确定要退出嘛？',
        settings_logout_confirm: '退出',
        settings_logout_cancel: '再看看',
        settings_logout_success: '退出成功',
        settings_take_photo: '拍照',
        settings_choose_album: '从手机相册选择',

        my_not_logged_in: '未登录',
        my_sign_placeholder: '请设置你的个性签名',
        my_minutes: '分钟',
        my_read_today: '今日阅读时长',
        my_wallet: '我的钱包',
        my_bean_balance: '书豆余额',
        my_today_bean: '今日书豆',
        my_topup_now: '立即充值',
        my_vip_until: '畅读VIP会员至{0}到期',
        my_vip_lifetime: '畅读VIP终身会员',
        my_vip_open: '开通会员享受更多福利',
        my_vip_center: '会员中心',
        my_vip_open_btn: '去开通',
        my_messages: '我的消息',
        my_settings: '设置',
        my_menu_1: '邀请好友',
        my_menu_2: '阅读喜好',
        my_menu_3: '阅读记录',
        my_menu_4: '我的书评',
        my_menu_5: '联系客服',
        my_menu_6: '我的会员',
        my_menu_7: '创作者中心',

        welfare_title: '福利',
        welfare_beans: '书豆',
        welfare_sign_today: '今日签到可领取',
        welfare_sign_now: '立即签到',
        welfare_sign_week: '本周签满7天 最多可领',
        welfare_daily: '日常福利',
        welfare_invite_reward: '邀请好友注册可获得书豆奖励',
        welfare_go_invite: '去邀请',
        welfare_read_daily: '每日阅读福利',
        welfare_today_read: '今日已读：',
        welfare_read_total: '累计阅读{0}分钟',
        welfare_read_reach: '阅读时长达到{0}分钟即可领{1}书豆',
        welfare_claimed: '已领取',
        welfare_go_read: '去阅读',
        welfare_sign_success: '恭喜您，签到成功',
        welfare_get: '获得',
        welfare_ok: '好的',

        login_forget_pwd: '找回密码',
        login_set_password: '请设置密码',
        login_confirm_password: '请再次输入密码',
        login_have_account: '已有账号？',
        login_confirm: '确认',
        login_forget_success: '找回成功',
        login_invite_code_placeholder: '请输入邀请码',
        login_register_success: '注册成功',
        agreement_title: '用户协议',
        privacy_title: '隐私政策',

        bookcase_title: '书架',
        bookcase_selected_count: '已选择{0}本',
        bookcase_search: '搜索书架',
        bookcase_today_read: '今日已读',
        bookcase_sign_beans: '签到送书豆',
        bookcase_empty: '书架空空~',
        bookcase_remove: '移出书架',
        bookcase_record: '阅读记录',
        bookcase_organize: '整理书架',
        bookcase_sort: '图书排序',
        bookcase_sort_update: '更新时间优先',
        bookcase_sort_read: '阅读时间优先',
        bookcase_select_all: '全选',
        bookcase_unselect_all: '取消全选',
        bookcase_select_remove: '请选择需要移除的书籍！',
        bookcase_remove_title: '移除',
        bookcase_remove_msg: '确定要将书籍移除吗？',
        bookcase_no_organize: '暂无书籍可以整理哦！',

        search_placeholder: '请输入书名或者作者名',
        search_history: '搜索历史',
        search_clear: '清空',
        search_hot: '热门搜索',
        search_recommend: '热门推荐',
        search_all_results: '全部结果',
        search_no_books: '暂时没有该书籍哦！',
        search_no_clear: '暂时没有要清空的记录哦！',
        search_clear_title: '清空',
        search_clear_msg: '确定要清空嘛？',
        search_score: '评分',

        reading_prev_chapter: '上一章',
        reading_next_chapter: '下一章',
        reading_bg: '背景',
        reading_font: '字体',
        reading_font_size_toast: '当前字号：{0}',
        reading_auto_buy: '自动购买付费章节',
        reading_order_normal: '正序',
        reading_order_reverse: '倒序',
        reading_pay_order: '订购',
        reading_per_chapter: '/章',
        reading_buy_chapter: '购买本章',
        reading_vip_free_all: '会员免费看全部书籍',
        reading_vip_free_before: '会员',
        reading_vip_free_after: '看全部书籍',
        reading_open_vip: '开通会员',
        reading_topup_beans: '充值书豆',

        vip_open: '开通会员',
        vip_until_at: '畅读VIP会员至{0}到期',
        vip_privilege_tip: '开通享有所有畅读VIP特权',
        vip_renew: '立即续费',
        vip_open_now: '立即开通',
        vip_benefits: '会员权益',
        vip_choose_package: '选择套餐',
        vip_gift_days: '送{0}天',
        vip_honor: '尊享会员',
        vip_pay_weixin: '微信支付',
        vip_pay_alipay: '支付宝支付',

        wallet_title: '我的钱包',
        wallet_bean_balance: '书豆余额',
        wallet_withdraw: '提现',
        wallet_about_rmb: '约{0}元',
        wallet_topup: '充值',
        wallet_today_bean: '今日书豆',
        wallet_total_bean: '累计书豆数',
        wallet_bean_intro: '书豆说明',
        wallet_what_bean: '什么是书豆？',
        wallet_detail: '书豆明细',

        record_title: '阅读记录',
        record_shelf: '书架',
        record_delete: '删除',
        record_empty: '暂无阅读记录，快去看书吧！',

        binding_title: '账号和绑定设置',
        binding_phone: '手机号设置',
        binding_bound: '已绑定',
        binding_go_bind: '去绑定',

        topup_title: '充值中心',
        topup_gift: '赠送{0}书豆',
        topup_tip_title: '温馨提示',
        topup_tip_msg: '如果充值失败，请尽快联系我们的客服。您可以从"我的"页面，点击"在线客服"进行反馈，谢谢亲',
        topup_success: '充值成功',
        topup_weixin_toast: '微信支付',
        topup_alipay_toast: '支付宝支付',

        invite_title: '邀请好友赚书豆',
        invite_rules: '活动规则',
        invite_slogan: '邀好友送书豆啦',
        invite_sub: '书豆上不封顶',
        invite_cash: '可变现',
        invite_tip: '被邀请的好友需注册后才可获得相应的奖励',
        invite_btn: '立即邀请',
        invite_reward: '邀请奖励',
        invite_day: '第{0}天',
        invite_read_min: '好友阅读{0}分钟',
        invite_flow: '邀请流程',
        invite_flow1: '发送邀请链接或二维码',
        invite_flow2: '好友下载并注册APP',
        invite_flow3: '好友注册成功你赚书豆',
        invite_tips: '邀请小技巧',
        invite_get_fail: '获取失败',

        system_title: '我的消息',
        system_tab_sys: '系统消息',
        system_tab_praise: '收到的赞',
        system_tab_review: '我的书评',
        system_view_detail: '查看详情',
        system_no_msg: '暂无消息',
        system_delete_confirm_title: '删除',
        system_delete_confirm_msg: '确定删除评论？',

        customer_title: '联系客服',
        customer_contact: '联系方式',
        customer_contact_tip: '您可以拨打客服联系电话，也可以联系客服微信QQ，即可在线沟通客服',
        customer_copy: '复制',
        customer_copied: '已复制',
        customer_faq: '常见问题',
        customer_copy_ok: '复制成功',
        customer_copy_fail: '该浏览器或手机权限不支持复制功能',

        replace_binding_title: '更换绑定',
        replace_phone_title: '绑定手机号',
        replace_phone_placeholder: '请输入您的手机号码',
        replace_change_phone_title: '更换手机号',
        replace_change_phone_msg: '确定要更换手机号嘛？',
        replace_confirm_change: '更换',
        replace_success: '成功更换',
        replace_bind_success: '绑定成功',
        login_set_password_8: '请设置至少8位数密码',

        fond_choose_type: '请选择您喜欢的类型',
        fond_recommend: '为您推荐喜欢的内容',
        fond_sheet_title: '请选择您的阅读喜好',
        fond_set_success: '设置成功',

        subsidiary_detail_title: '提现详情',
        subsidiary_success: '提现成功',
        subsidiary_arrive_time: '到账时间',
        subsidiary_arrive_way: '到账方式',
        subsidiary_arrive_amount: '到账金额',
        subsidiary_weixin: '微信',
        subsidiary_alipay: '支付宝',
        subsidiary_got_it: '我知道了',
        subsidiary_list_title: '提现明细',
        subsidiary_withdraw_bean: '提现{0}书豆',
        subsidiary_audit: '审核中',
        subsidiary_fail: '提现失败',
        subsidiary_empty: '暂无提现记录',

        personality_title: '设置个性签名',
        personality_save: '保存',

        progress_title: '提现进度',
        progress_submit: '{0}元提现申请已提交',
        progress_got_it: '我知道了',
        progress_tip: '您可以在提现明细里面查看提现详情',

        rules_title: '活动规则',

        withdrawal_title: '我要提现',
        withdrawal_detail: '明细',
        withdrawal_bean_withdraw: '书豆提现',
        withdrawal_rmb: '提现{0}元',
        withdrawal_way: '提现方式',
        withdrawal_weixin_account: '微信账户',
        withdrawal_alipay_account: '支付宝账户',
        withdrawal_add_account: '添加提现账户',
        withdrawal_select_amount: '请选择提现金额',
        withdrawal_select_account: '请选择提现账户',
        withdrawal_confirm_title: '提现',
        withdrawal_confirm_msg: '确定要进行提现吗？',
        withdrawal_think_again: '再想想',
        withdrawal_success: '提现成功',

        system_detail_title: '系统消息',

        account_title: '添加提现账户',
        account_type_placeholder: '请选择账户类型',
        account_placeholder: '请输入账号',
        account_name_placeholder: '请输入账户姓名',
        account_weixin: '微信账户',
        account_alipay: '支付宝账户',

        binding_toast_weixin: '绑定微信登录',
        binding_toast_qq: '绑定QQ登录',
        binding_unbind_weixin_title: '解除微信绑定',
        binding_unbind_weixin_msg: '确定要解除微信绑定嘛？一旦解除将不能再微信登录',
        binding_unbind_qq_title: '解除QQ绑定',
        binding_unbind_qq_msg: '确定要解除QQ绑定嘛？一旦解除将不能再QQ登录',
        binding_unbind_btn: '解除',

        record_clear_title: '清空',
        record_clear_msg: '确定要清空阅读记录吗？',
        record_delete_msg: '确定删除吗？',

        vip_choose_package_toast: '请选择需要开通的套餐！',

        welfare_free_unlock: '免费解锁',
        welfare_watch_video: '观看广告',
        welfare_watch_video_desc: '看一个广告获得奖励',
        welfare_watch_video_remain: '剩余{0}次',
        welfare_watch_video_full: '今日观看次数已用完',
        welfare_visit_site: '访问网站',
        welfare_visit_site_desc: '阅读一篇文章并停留20秒可获得奖励',
        welfare_visit_site_remain: '剩余{0}次',
        welfare_visit_site_full: '今日访问次数已用完',
        welfare_visit_site_timer: '{0}秒后领取',
        welfare_visit_site_claim: '领取书豆',
        welfare_visit_site_too_short: '阅读时长不足，请重新尝试',
        open_browser_tip: '跳转到外部浏览器会拥有更好的体验',
        welfare_popup_title: '书豆不足，免费去赚？',
        welfare_popup_go: '去福利中心赚书豆',
        guest_topup_success_title: '充值成功！',
        guest_topup_success_msg: '书豆已存入您的临时账户。登录后可永久保存，并在任何设备上使用。',
        guest_login_now: '立即登录 / 注册',
        guest_later: '暂不登录',

        book_read_progress: '已读{0}章/{1}章',
        book_unread: '未读',
        review_from_book: '来自:《{0}》',
        currency_cny_suffix: '元',

        share_arrow_tip: '点击右上角"..."',
        share_earn_coins: '分享赚书豆',
        share_subtitle: '海量全网热门正版书籍',
        share_recommend: '书友力荐',
        share_slogan: '随时随地 想看就看',
        share_more: '更多内容等你体验',
    },
    api: {
        add_success: '添加成功',
        update_success: '更新成功',
        delete_success: '删除成功',
        restore_success: '恢复成功',
        operation_success: '操作成功',
        review_success: '审核成功',
        topup_success: '充值成功',
        publish_success: '发布成功',
        reply_success: '回复成功',
        purchase_success: '购买成功',
        remove_success: '移除成功',
        clear_success: '已清空',
        join_success: '加入成功',
        reward_success: '打赏成功',
        apply_success: '申请成功',
        apply_success_pending: '申请成功，请等待审核',
        like_success: '点赞成功',
        cancel_success: '取消成功',
        send_success: '发送成功',
        claim_success: '领取成功',
        logout_success: '退出成功',
        unbind_success: '已解除绑定',
        publish_failed: '发布失败',
        verify_failed: '核销失败',
        operation_failed: '操作失败',
        update_failed: '设置失败',
        fetch_failed: '获取失败',
        book_create_failed: '书籍创建失败',
        chapter_exists: '章节已存在',
        param_error: '参数错误',
        account_error: '账号错误',
        account_password_error: '账号密码错误',
        captcha_error: '验证码错误',
        content_required: '内容不能为空',
        phone_required: '请填写手机号',
        identifier_required: '请填写标识',
        user_wechat_not_bound: '用户未绑定微信',
        writer_not_verified: '未认证创作者',
        writer_reviewing: '创作者审核中',
        writer_review_failed: '创作者审核失败',
        api_key_error: 'api 密钥错误',
        // --- Service layer errors ---
        add_failed: '添加失败',
        delete_failed: '删除失败',
        restore_failed: '恢复失败',
        review_failed: '审核失败',
        upload_failed: '上传失败',
        topup_failed: '充值失败',
        topup_payment_failed: '充值支付失败',
        topup_info_not_found: '查找不到充值信息',
        topup_once_limit: '该充值项目只限制充值一次，请选择别的项目充值',
        bind_failed: '绑定失败',
        already_bound_other_account: '已绑定其他账号',
        already_bound: '请勿重复绑定',
        bind_same_phone: '请勿重新绑定同一手机号',
        register_failed: '新用户注册失败',
        order_not_found: '订单不存在',
        order_create_failed: '订单创建失败',
        user_not_found: '用户不存在',
        phone_invalid: '手机号不正确',
        phone_registered: '手机号已被注册',
        account_name_required: '请填写账号姓名',
        password_required: '未填写密码',
        password_mismatch: '两次密码输入不一致',
        original_password_error: '原始密码错误',
        password_change_failed: '修改密码失败',
        password_already_set: '密码已设置',
        account_disabled: '账号已被禁用，请联系客服',
        insufficient_coins: '书币不够，请充值',
        commission_ratio_exceeded: '佣金比例不能超过自身的比例',
        daily_visits_exceeded: '今日访问次数已用完',
        daily_watch_exceeded: '今日观看次数达到上限',
        already_liked: '你已经点赞过',
        already_collected: '你已经收藏',
        already_applied: '请勿重复申请',
        already_added: '已添加，请勿重复添加',
        please_login: '请先登录',
        paid_chapter_login_required: '付费章节，请登录后阅读',
        read_preference_required: '请选择您的阅读喜好',
        book_type_required: '请选择您喜欢的类型',
        nickname_required: '请输入要更改的昵称',
        keyword_required: '请输入关键词',
        comment_required: '评论内容不能为空',
        nickname_in_use: '笔名已被使用',
        unsupported_platform: '不支持的第三方平台',
        re_login_third_party: '请重新通过第三方平台登录',
        param_required: '参数不能为空',
        product_type_not_found: '产品类型不存在',
        payment_type_invalid: '支付类型参数不对',
        receipt_required: '支付收据不能为空',
        payment_verify_failed: '支付验证失败',
        unified_order_failed: '统一下单接口调用失败',
        withdraw_amount_zero: '提现金额不能为0',
        withdraw_amount_min: '提现金额错误，最低提现金额不能小于1元',
        withdraw_failed: '提现失败',
        withdraw_info_not_found: '未获取到提现信息',
        withdraw_apply_success: '申请提现成功，请等待平台进行审核打款',
        apply_failed: '申请失败，请重试',
        publish_failed_retry: '发布失败，请重试',
        operation_failed_retry: '操作失败，请重试',
        request_failed: '请求失败，请稍后再试',
        h5_domain_required: '请配置h5站点域名',
        missing_upload_image: '缺少上传的图像文件',
        missing_upload_file: '缺少上传的文件',
        missing_user_profile: '缺少用户资料',
        missing_code_param: '缺少参数CODE，请检查',
        chapter_not_found: '找不到该章节目录',
        message_type_invalid: '消息类型不正确',
        agent_account_exists: '代理账号已经存在',
        account_type_required: '请选择账户类型',
        message_id_required: '请选择消息ID',
        message_type_required: '请选择消息类型',
        openid_required: 'OPENID不能为空',
        waiting_scan: '等待用户扫码...',
    },
}
